package com.vizio.redwolf.auth.utils

import kotlin.js.JsExport

@JsExport
data class TokenRefreshReason(
    val errorCode: String
)
